import dayjs from "dayjs";

export const isStartDateIsGreaterThanEndDate = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
  const diff = endDate.diff(startDate);
  return diff < 0;
};

export const isGapMoreThanNDays = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs, days: number) => {
  const diffInDays = endDate.diff(startDate, "days");
  return diffInDays > days;
};

export const getCurrentDateTime = (date?: Date, forApi: boolean = false): string => {
  const now = date || new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return forApi
    ? `${year}-${month}-${day}%${hours}:${minutes}:${seconds}`
    : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export function getLast12Months() {
  const months = [];
  const currentDate = new Date();
  
  for (let i = 0; i < 12; i++) {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i);
    const options = { month: 'short', year: 'numeric' } as const; 
    months.push(date.toLocaleDateString('en-US', options).replace(',', ''));
  }

  return months; 
}

export const formatDateToDateMonthYear = (dateString: string | Date): string => {
  if (!dateString) return '';
  return dayjs(dateString).format('DD MMM, YYYY');
};

// Utility function to get current UTC timestamp
export const getCurrentUTCTimestamp = (): string => {
  return new Date().toISOString();
};

// Utility function to add minutes to UTC timestamp
export const addMinutesToUTCTimestamp = (timestamp: string, minutes: number): string => {
  const date = new Date(timestamp);
  date.setMinutes(date.getMinutes() + minutes);
  return date.toISOString();
};

// Utility function to check if timestamp has expired
export const isTimestampExpired = (expiryTime: string): boolean => {
  const now = new Date();
  const expiry = new Date(expiryTime);
  return now >= expiry;
};
